import React from 'react'
import { t } from 'ttag'

import { Pagination } from 'components/shared/Table/common/Pagination/Pagination'
import { Table } from 'components/shared/Table/Table'

import { useJobsTable } from './hooks'
import { getFiltersConfigs } from './model'
import { JobsTableHeader } from './JobsTableHeader'
import { JobsTableBody } from './JobsTableBody'

import { getIsFilteredResults } from '../../../helpers'

const mapSortingPropToQueryParam = {
  candidates_count: 'candidates_count',
  department: 'department',
  name: 'name',
  positions: 'positions',
  start_date: 'start_date',
  selection_stage: 'selection_stage',
  updated: 'updated',
}

export const JobsTable = ({ search, filter, resetFilter }) => {
  const { state, handlers } = useJobsTable({
    mapSortingPropToQueryParam,
    search,
    filter,
  })

  const {
    table: {
      headers,
      model,
      rowSelection,
      isAllRowsSelected,
      isFetching,
      isSomeRowsSelected,
    },
    pagination: { currentPage, pageCount, perPage },
  } = state
  const {
    handleStep,
    pagination: { handlePage, handlePageSize },
    table: { toggleAllRowsSelectedHandler },
  } = handlers

  const placeholder = React.useMemo(() => {
    const isFilteredResults = getIsFilteredResults(getFiltersConfigs(), filter)

    if (isFilteredResults) {
      return {
        title: t`There are no jobs matching the selected filters`,
        text: <div onClick={resetFilter}>{t`reset filters`}</div>,
      }
    }

    return {
      title: t`No active jobs yet`,
      text: t`Click “+ New job“ to continue`,
    }
  }, [filter])

  return (
    <>
      <Table>
        <JobsTableHeader
          headers={headers}
          isAllRowsSelected={isAllRowsSelected}
          isSomeRowsSelected={isSomeRowsSelected}
          isFetching={isFetching}
          onToggleAllRowsSelected={toggleAllRowsSelectedHandler}
        />
        <JobsTableBody
          model={model}
          rowSelection={rowSelection}
          isFetching={isFetching}
          placeholder={placeholder}
          handleStep={handleStep}
        />
      </Table>
      <Pagination
        onSetPage={handlePage}
        onSetPageSize={handlePageSize}
        {...{ currentPage, pageCount, perPage }}
      />
    </>
  )
}
